import { Action, createSlice } from "@reduxjs/toolkit";
import { UiSettingsActionTypes, UiSettingsState } from "../types/uiSettingsState.types";
import { UI_SETTINGS_SLICE_NAME } from "../utils/storeUtils";

const initialState: UiSettingsState = {
  builderSelectedTab: "Fields",
  dragSessionId: "",
};
export const uiSettingsSlice = createSlice({
  name: UI_SETTINGS_SLICE_NAME,
  initialState: initialState,
  reducers: {
    setTab: (state, action: UiSettingsActionTypes["setTab"]) => {
      state.builderSelectedTab = action.payload;
    },
    setDragSessionId: (state, action: UiSettingsActionTypes["setDragSessionId"]) => {
      state.dragSessionId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action: Action) => action.type === `${UI_SETTINGS_SLICE_NAME}/setDragSessionId`,
      (state) => {
        state.builderSelectedTab = "Fields";
      }
    );
  },
});

export default uiSettingsSlice.reducer;
